import React, { Component } from 'react';
import JsonViewer from './index';
import { SingleJsonViewer } from './index';
import { 
  modalWrap,
  pannelWrap,jsonViewerWrap,
} from '../zHistoryLog/style.css'
import { appendStyle } from './JsonViewerPannel.css'
import { Modal } from 'bee'
import "bee-modal/build/Modal.css"
const JsonViewerComparePannel =  (props) => { // json对比面板
  let { leftTitle={},leftJson={},rightTitle={},rightJson={} } = props;
  return (
    <Modal
      className={`${modalWrap} ${appendStyle} expand`}
      show = { true }
      onHide = { props.destory }
      backdrop={false} >
        <Modal.Header closeButton>
            <Modal.Title>
              {
                historyLogLang.template("P_YS_PF_GZTLOG_0000083158") /* "对比操作" */
              }
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={pannelWrap}>
            <div className={jsonViewerWrap}>
              <div style={{"width":'100%','height':'100%'}} >
              {
                <JsonViewer leftTitle={leftTitle} jsonDataLeft={leftJson} rightTitle={rightTitle} jsonDataRight={rightJson} />
              }
              </div>
            </div>
            <div className='example'>
            {
              <div>
                <span>{historyLogLang.template("P_YS_FED_EXAMP_0000019871") /* "删除" */}</span>
                <span>{historyLogLang.template("P_YS_FED_FW_0000021020") /* "新增" */}</span>
                <span>{historyLogLang.template("P_YS_FED_FW_0000022188") /* "更新" */}</span>
              </div>
            }
              <button onClick={props.destory}>{historyLogLang.template("P_YS_PF_GZTLOG_0001068839") /* "关闭" */}</button>
            </div>
          </div>
        </Modal.Body>
    </Modal>
  )
}

const JsonViewerPannel =  (props) => { // json展示面板
  let { title={},json={}, } = props;
  return (
    <Modal
      className={`${modalWrap} ${appendStyle} expand`}
      show = { true }
      onHide = { props.destory }
      backdrop={false} >
        <Modal.Header closeButton>
            <Modal.Title>
              {
                historyLogLang.template("P_YS_PF_GZTLOG_0000083159") /* "详细数据" */
              }
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={pannelWrap}>
            <div className={jsonViewerWrap}>
              <div style={{"width":'100%','height':'100%'}} >
              {
                <SingleJsonViewer title={title} jsonData={json} />
              }
              </div>
            </div>
            <div className='example'>
            {
              <p>{JSON.stringify(json) == '{}'?historyLogLang.template("P_YS_PF_GZTLOG_0000080579") /* "没有详细数据，请检查数据上是否存在" */:''}</p>
            }
              <button onClick={props.destory}>{historyLogLang.template("P_YS_PF_GZTLOG_0001068839") /* "关闭" */}</button>
            </div>
          </div>
        </Modal.Body>
    </Modal>
  )
}

export {
  JsonViewerComparePannel,
  JsonViewerPannel
}



// WEBPACK FOOTER //
// ./src/components/zTestJson/JsonViewerPannel.js